import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface DmsSyncResponse {
  started: boolean;
  reason?: string;
}

@Injectable({
  providedIn: 'root',
})
export class DmsService {
  private readonly apiUrl = `${environment.apiUrl}/delivery-note`;

  constructor(private http: HttpClient) {}

  public sync(): Observable<DmsSyncResponse> {
    return this.http.post<DmsSyncResponse>(`${this.apiUrl}/dms-sync`, {});
  }
}
